'use client';

import { c as _c } from "react/compiler-runtime";
import type { InputProps, InputRef } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import React, { useCallback, useEffect, useRef } from 'react';
import { cn } from '@/libs/utils';
import { AuthInput } from './AuthInput';
interface EmailPhoneInputProps extends Omit<InputProps, 'value' | 'onChange'> {
  label: string;
  errorMessage?: string;
  value?: string;
  onChange?: InputProps['onChange'];
  type?: 'email' | 'phone';
  classNames?: {
    input?: string;
    label?: string;
    error?: string;
  };
}
const PHONE_MASK = '+0 (000) 000-00-00';
const PHONE_MASK_OPTIONS = {
  lazy: false as const
};
export const EmailPhoneInput = t0 => {
  const $ = _c(23);
  let classNames;
  let errorMessage;
  let label;
  let onChange;
  let rest;
  let type;
  let value;
  if ($[0] !== t0) {
    ({
      label,
      errorMessage,
      value,
      onChange,
      classNames,
      type,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = classNames;
    $[2] = errorMessage;
    $[3] = label;
    $[4] = onChange;
    $[5] = rest;
    $[6] = type;
    $[7] = value;
  } else {
    classNames = $[1];
    errorMessage = $[2];
    label = $[3];
    onChange = $[4];
    rest = $[5];
    type = $[6];
    value = $[7];
  }
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  let t1;
  let t2;
  if ($[8] !== type) {
    t1 = () => {
      if (type === "email") {
        emailRef.current?.focus?.();
      } else {
        phoneRef.current?.focus?.();
      }
    };
    t2 = [type];
    $[8] = type;
    $[9] = t1;
    $[10] = t2;
  } else {
    t1 = $[9];
    t2 = $[10];
  }
  useEffect(t1, t2);
  let safeProps;
  if ($[11] !== rest) {
    const {
      defaultValue,
      ...t3
    } = rest;
    safeProps = t3;
    $[11] = rest;
    $[12] = safeProps;
  } else {
    safeProps = $[12];
  }
  let t3;
  if ($[13] !== onChange) {
    t3 = e => {
      onChange?.(e);
    };
    $[13] = onChange;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const handleChange = t3;
  let t4;
  if ($[15] !== classNames || $[16] !== errorMessage || $[17] !== handleChange || $[18] !== label || $[19] !== safeProps || $[20] !== type || $[21] !== value) {
    t4 = type === "email" ? <AuthInput label={label} errorMessage={errorMessage} value={value} onChange={handleChange} classNames={classNames} inputRef={emailRef} {...safeProps} /> : <label className={cn("flex flex-col gap-1 text-base text-[#AAAAB6]", classNames?.label)}>{label}<MaskedInput mask={PHONE_MASK} maskOptions={PHONE_MASK_OPTIONS} value={value ?? ""} onChange={handleChange} style={{
        borderColor: errorMessage ? "#ED3F3F" : "#FFFFFF1A"
      }} size="large" className={cn("h-[42px]  w-full rounded-lg border-2 border-[#FFFFFF1A] bg-[#FFFFFF0F] pl-2", classNames?.input)} ref={instance => {
        const inputEl = instance?.input ?? null;
        phoneRef.current = inputEl;
      }} {...safeProps} />{errorMessage && <span className={cn("text-[14px] text-base text-[#ED3F3F]", classNames?.error)}>{errorMessage}</span>}</label>;
    $[15] = classNames;
    $[16] = errorMessage;
    $[17] = handleChange;
    $[18] = label;
    $[19] = safeProps;
    $[20] = type;
    $[21] = value;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  return t4;
};